"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeBlockOptions = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const BasicButtonMore_1 = require("@jsonjoy.com/ui/lib/2-inline-block/BasicButton/BasicButtonMore");
const Checkbox_1 = require("@jsonjoy.com/ui/lib/2-inline-block/Checkbox");
const Input_1 = require("@jsonjoy.com/ui/lib/2-inline-block/Input");
const Slider_1 = require("@jsonjoy.com/ui/lib/2-inline-block/Slider");
const ContextMenu_1 = require("@jsonjoy.com/ui/lib/4-card/ContextMenu");
const Separator_1 = require("@jsonjoy.com/ui/lib/3-list-item/Separator");
const Popup_1 = require("@jsonjoy.com/ui/lib/4-card/Popup");
const FormRow_1 = require("@jsonjoy.com/ui/lib/3-list-item/FormRow");
const MoveToViewport_1 = require("@jsonjoy.com/ui/lib/utils/popup/MoveToViewport");
const state_1 = require("./state");
const Space_1 = require("@jsonjoy.com/ui/lib/3-list-item/Space");
const LANGUAGE_OPTIONS = [
    'bash',
    'c',
    'cpp',
    'css',
    'go',
    'html',
    'java',
    'js',
    'json',
    'jsx',
    'py',
    'rust',
    'sh',
    'sql',
    'text',
    'toml',
    'ts',
    'tsx',
    'yaml',
    'zsh',
];
const blockClass = (0, nano_theme_1.rule)({
    bxz: 'border-box',
    d: 'flex',
    fld: 'column',
    gap: '12px',
    maxW: '400px',
});
const popupFieldRowClass = (0, nano_theme_1.rule)({
    d: 'grid',
    gridTemplateColumns: '1fr auto',
    gap: '8px',
    ai: 'center',
});
const stopInputKeyDown = (event) => {
    event.stopPropagation();
};
const preventPopupMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
};
const CodeBlockOptions = () => {
    const state = (0, state_1.useCodeBlockOptionsState)();
    const fileName = state.fileName.use();
    const language = state.language.use();
    const wrapColumn = state.wrapColumn.use();
    const showLineNumbers = state.showLineNumbers.use();
    const languageMenu = {
        name: 'Language',
        minWidth: 220,
        children: [
            {
                id: 'plain-text',
                name: 'Plain text',
                onSelect: () => state.setLanguage(''),
                right: !language.trim() ? () => React.createElement("span", { style: { fontSize: 11, opacity: 0.6 } }, "Current") : undefined,
            },
            { id: 'language-sep', name: 'language-sep', sep: true },
            ...LANGUAGE_OPTIONS.map((option) => ({
                id: option,
                name: option,
                display: () => React.createElement("code", null,
                    ".",
                    option),
                onSelect: () => state.setLanguage(option),
                right: language.trim().toLowerCase() === option
                    ? () => React.createElement("span", { style: { fontSize: 11, opacity: 0.6 } }, "Current")
                    : undefined,
            })),
        ],
    };
    return (React.createElement("div", { className: blockClass },
        React.createElement(Input_1.Input, { type: "text", value: fileName, label: "File name", placeholder: "file.txt", focus: true, onChange: state.setFileName, onKeyDown: stopInputKeyDown, onEnter: (event) => {
                event.preventDefault();
                event.stopPropagation();
                state.apply();
            }, onEsc: (event) => {
                event.preventDefault();
                event.stopPropagation();
                state.cancel();
            }, onBlur: state.inferLanguageFromFileName }),
        React.createElement("div", { className: popupFieldRowClass },
            React.createElement(Input_1.Input, { type: "text", value: language, label: "Language", placeholder: "txt", onChange: state.setLanguage, onKeyDown: stopInputKeyDown, onEnter: (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    state.apply();
                }, onEsc: (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    state.cancel();
                } }),
            React.createElement(Popup_1.Popup, { renderContext: () => (React.createElement(MoveToViewport_1.MoveToViewport, { vertical: true },
                    React.createElement(ContextMenu_1.ContextMenu, { inset: true, menu: languageMenu }))) },
                React.createElement(BasicButtonMore_1.BasicButtonMore, { type: "button", size: 32, compact: true, rounder: true, onMouseDown: preventPopupMouseDown }))),
        React.createElement(Space_1.Space, { size: -6 }),
        React.createElement(Separator_1.Separator, null),
        React.createElement(FormRow_1.FormRow, { title: "Wrap guide", descriptionAbove: true, description: "Adjust the wrapping guide column position." },
            React.createElement(Slider_1.Slider, { value: wrapColumn, min: 10, max: 140, step: 1, showValue: true, onChange: state.setWrapColumn })),
        React.createElement(Separator_1.Separator, null),
        React.createElement(FormRow_1.FormRow, { title: "Show line numbers", description: "Show or hide the line number gutter on the left side of the code block.", right: true },
            React.createElement("div", { style: { width: 60, marginTop: -8 } },
                React.createElement(Checkbox_1.Checkbox, { on: showLineNumbers, onChange: state.toggleShowLineNumbers })))));
};
exports.CodeBlockOptions = CodeBlockOptions;
